/**
 * @hardcoded Fallback emojis used when a slug has no entry in the per-step emoji map.
 * @fix Add `iconUrl` to `SurveyStepOption` in the GraphQL schema and render from
 *   the API value. Then remove this array and the per-step `OPTION_EMOJIS` maps in
 *   SingleSelectStep and MultiSelectStep.
 */
export const OPTION_EMOJIS_FALLBACK = [
  '\u{1F4BB}',
  '\u{1F535}',
  '\u{2692}\u{FE0F}',
  '\u{1F916}',
  '\u{270F}\u{FE0F}',
  '\u{1F984}',
]

/**
 * @hardcoded Colours assigned by position (`ICON_COLORS[index % length]`), not by
 *   option identity. Reordering options in the API silently changes which colour
 *   each option gets.
 * @fix Add `backgroundColor` (or reuse `accentColor`) to `SurveyStepOption` in the
 *   GraphQL schema. Remove this positional cycling.
 */
export const ICON_COLORS = [
  'var(--color-bg-upgrade)',
  'var(--color-bg-alpha)',
  'var(--color-bg-brand-subtle)',
  'var(--color-bg-new)',
  'var(--color-bg-beta)',
  'var(--color-bg-critical-a-subtle)',
  'var(--color-bg-info-subtle)',
]
